import { CardTitle, CardDescription } from "@/components/ui/card";

export const UtthungaHeader = () => {
  return (
    <div className="flex items-center gap-6 justify-between mb-8">
      <div className="flex items-center gap-6">
        <img 
          src="/lovable-uploads/utthunga-logo.png" 
          alt="Utthunga Logo" 
          className="w-36 h-36 object-contain"
        />
        <div>
          <CardTitle className="text-2xl font-bold mb-2">Utthunga</CardTitle>
          <CardDescription className="text-lg">
            Product Engineering & Industrial Solutions — Engineering Transformation for OEMs and Industries
          </CardDescription>
        </div>
      </div>
    </div>
  );
};
